import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { useMq } from '../common/mediaquery';

//basicSlider
const basicSlider = document.querySelectorAll<HTMLElement>(".js-basic-slide");

if (basicSlider.length > 0) {
  for (let i = 0; i < basicSlider.length; i++) {
    basicSlider[i].className += i;

    const slideCount = basicSlider[i].querySelectorAll(".splide__slide").length;
    const parPageNum = Number(basicSlider[i].dataset.perpage);
    const gapValue = basicSlider[i].dataset.gap;
    const gapValueSp = basicSlider[i].dataset.gapsp;
    const onlyKey = basicSlider[i].dataset.only;
    const basicSliderList = basicSlider[i].querySelector<HTMLElement>(".splide__list");
    const autoPlay = basicSlider[i].dataset.autoplay;

    type Options = {
      type: string,
      perPage: number,
      perMove: number,
      gap: string,
      destroy: boolean,
      autoplay?: boolean,
      interval?: number,
      speed?: number,
      breakpoints: {
        749: {
          gap: string,
          perPage: number,
          destroy: boolean
        }
      }
    }

    const options: Options = {
      type: 'loop',
      perPage: parPageNum,
      perMove: 1,
      gap: gapValue,
      destroy: false,
      breakpoints: {
        749: {
          gap: gapValueSp,
          perPage: 1,
          destroy: false
        }
      }
    }

    if(autoPlay) {
      options.autoplay = true;
      options.interval = Number(autoPlay);
      options.speed = 1000;
    }

    const sliderInit = (options) => {
      useMq({
        type: 'max',
        query: '749px',
        onMatch: () => {
          new Splide( '.js-basic-slide' + String(i), options ).mount();
        },
        onUnmatch: () => {
          if(slideCount > parPageNum) {
            new Splide( '.js-basic-slide' + String(i), options ).mount();
          } else {
            new Splide( '.js-basic-slide' + String(i), options ).mount().destroy();
            basicSliderList.style.display = "grid";
    
            useMq({
              type: 'max',
              query: '749px',
              onMatch: () => {
                basicSliderList.style.gridTemplateColumns = "1fr";
                basicSliderList.style.rowGap = gapValue;
                basicSliderList.style.columnGap = gapValue;
              },
              onUnmatch: () => {
                basicSliderList.style.gridTemplateColumns = "repeat(" + String(parPageNum) + ", 1fr)";
                basicSliderList.style.rowGap = gapValue;
                basicSliderList.style.columnGap = gapValue;
              }
            })
          }
        }
      })
    }

    if(onlyKey === 'sp') {
      options.destroy = true;
      sliderInit(options);
      useMq({
        type: 'max',
        query: '749px',
        onMatch: () => {
          basicSliderList.style.display = null;
          basicSliderList.style.gridTemplateColumns = null;
          basicSliderList.style.rowGap = null;
          basicSliderList.style.columnGap = null;
        },
        onUnmatch: () => {
          setTimeout(() => {
            basicSliderList.style.display = "grid";
            basicSliderList.style.gridTemplateColumns = "repeat(" + String(parPageNum) + ", 1fr)";
            basicSliderList.style.rowGap = gapValue;
            basicSliderList.style.columnGap = gapValue;
          }, 200);
        }
      })
    } else if(onlyKey === 'pc') {
      options.breakpoints[749].destroy = true;
      sliderInit(options);
      useMq({
        type: 'min',
        query: '768px',
        onMatch: () => {
          basicSliderList.style.display = null;
          basicSliderList.style.gridTemplateColumns = null;
          basicSliderList.style.rowGap = null;
          basicSliderList.style.columnGap = null;
        },
        onUnmatch: () => {
          setTimeout(() => {
            basicSliderList.style.display = "grid";
            basicSliderList.style.gridTemplateColumns = "1fr";
            basicSliderList.style.rowGap = gapValue;
            basicSliderList.style.columnGap = gapValue;
          }, 200);
        }
      })

    } else {
      sliderInit(options);
    }

  }
}

// infiniteSlider
const infiniteSlider = document.querySelectorAll(".js-infinite-slide");

if (infiniteSlider.length > 0) {
  for (let i = 0; i < infiniteSlider.length; i++) {
    infiniteSlider[i].className += i;

    let speedNum = 0.5;
    if (i % 2 == 0) {
      speedNum = 0.8;
    }

    const options = {
      type: 'loop',
      pagination: false,
      fixedWidth: 232,
      arrows: false,
      autoScroll: {
        speed: speedNum,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      gap: '8px',
      breakpoints: {
        751: {
          fixedWidth: 182,
        }
      }
    }

    new Splide( '.js-infinite-slide' + String(i), options ).mount({ AutoScroll});
  }
}

// anchorSlider
const anchorSlider = document.querySelectorAll(".js-anchor-slide");

if (anchorSlider.length > 0) {
  for (let i = 0; i < anchorSlider.length; i++) {
    anchorSlider[i].className += i;

    const options = {
      type: 'slide',
      autoWidth: true,
      gap: '1.25rem',
      pagination: false,
      arrows: true,
      autoScroll: false,
      destroy: true,
      focus: 0,
      omitEnd: true,
      breakpoints: {
        749: {
          destroy: false,
        } 
      }
    }

    new Splide( '.js-anchor-slide' + String(i), options ).mount();
  }
}

// heroSlider
const heroLeftSlider = document.querySelectorAll(".js-hero-left");

if (heroLeftSlider.length > 0) {
  for (let i = 0; i < heroLeftSlider.length; i++) {
    heroLeftSlider[i].className += i;

    const options = {
      type: 'fade',
      autoplay: true,
      speed: 1500,
      interval: 6000,
      arrows: false,
      pagination: false,
      pauseOnHover: false,
      rewind: true,
      drag: false,
      reducedMotion: {
        speed: 1000,
        autoplay: true,
      },
    }

    new Splide( '.js-hero-left' + String(i), options ).mount();
  }
}

// heroSlider
const heroRightSlider = document.querySelectorAll(".js-hero-right");

if (heroRightSlider.length > 0) {
  for (let i = 0; i < heroRightSlider.length; i++) {
    heroRightSlider[i].className += i;

    const options = {
      type: 'fade',
      autoplay: true,
      speed: 1500,
      interval: 6000,
      arrows: false,
      pagination: false,
      pauseOnHover: false,
      rewind: true,
      drag: false,
      reducedMotion: {
        speed: 1000,
        autoplay: true,
      },
    }

    new Splide( '.js-hero-right' + String(i), options ).mount();
  }
}


const cultureSlider = document.querySelectorAll(".js-culture-slide");

if (cultureSlider.length > 0) {
  for (let i = 0; i <cultureSlider.length; i++) {
    cultureSlider[i].className += i;

    const options = {
      type: 'loop',
      drag: false,
      pagination: false,
      perPage: 6,
      perMove: 1,
      arrows: false,
      focus: 0,
      omitEnd: true,
      fixedWidth: 380,
      gap: '1.25rem',
      autoScroll: {
          speed: 0.6,
          pauseOnHover: false,
          pauseOnFocus: false
      },
      breakpoints: {
        749: {
          type: 'loop',
          perPage: 1,
          gap: '0.75rem',
          pagination: false,
          fixedWidth: 294,
        }
      }
    }

    new Splide( '.js-culture-slide' + String(i), options ).mount({ AutoScroll });
  }
}

const galleryBottomSlider = document.querySelectorAll(".js-culture-slide02");

if (galleryBottomSlider.length > 0) {
  for (let i = 0; i <galleryBottomSlider.length; i++) {
    galleryBottomSlider[i].className += i;

    const options = {
      type: 'loop',
      drag: false,
      pagination: false,
      perPage: 6,
      perMove: 1,
      arrows: false,
      focus: 0,
      omitEnd: true,
      fixedWidth: 380,
      gap: '1.25rem',
      autoScroll: {
          speed: -0.6,
          pauseOnHover: false,
          pauseOnFocus: false
      },
      breakpoints: {
        749: {
          type: 'loop',
          perPage: 1,
          gap: '0.75rem',
          pagination: false,
          fixedWidth: 294,
        }
      }
    }

    new Splide( '.js-culture-slide02' + String(i), options ).mount({ AutoScroll });
  }
}